<template>
    <div class="w1200">
        <div class="head clearfix">
            <HT text="招贤纳士" class="fl"></HT>
            <div class="fr bread clearfix">
                <div class="fl" style="margin-right:15px;color: #064186">当前位置:</div>
                <div class="fl">
                    <el-breadcrumb separator-class="el-icon-arrow-right">
                        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                        <el-breadcrumb-item :to="{ path: '/recruit' }">招贤纳士</el-breadcrumb-item>
                        <el-breadcrumb-item :to="{ path: '/recruit/zpgw' }">招聘岗位</el-breadcrumb-item>
                        <el-breadcrumb-item :to="{ path: '/recruit/zpgwxq' }">招聘岗位详情</el-breadcrumb-item>
                    </el-breadcrumb>
                </div>
            </div>
        </div>
        <div v-for="(item,i) in list" :key="i" class="content">
            <p class="title">{{ item.title }}</p>
            <p v-html="item.text" style="padding:30px 55px"></p>
        </div>
    </div>
</template>

<script>
import HT from '@/components/h2.vue'
import { request } from '@/assets/utils/request'

export default {
    data() {
        return {
            list: []
        }
    },
    components: {
        HT
    },
    computed: {
        query() {
            return Number(this.$route.query.id)
        }
    },
    methods: {
        getList() {
            var that = this;
            request('/mocks/zpgwxq.json',{
                onSuccess(data) {
                    try {
                        data = JSON.parse(data)
                        let mdata = data.filter(item => { return item.id == that.query})
                        that.list = mdata
                    } catch (e) {
                        that.list = [];
                    }
                }
            })
        }
    },
    mounted() {
        this.$parent.isShow = false
        this.getList()
    }
}
</script>

<style scoped>
    .w1200{
        margin: 0 auto;
    }
    .bread{
        font-size: 14px;
        height: 20px;
        line-height: 20px;
        margin-top: 50px;
    }
    .el-breadcrumb{
        line-height: 20px;
    }
    .head{
        padding-bottom: 23px;
        border-bottom: 2px solid #134b8c;
    }
    .title{
        font-size: 28px;
    }
    .content{
        padding: 40px 0;
        line-height: 40px;
    }
</style>